import { render } from "./default.vue?vue&type=template&id=245ce78c&scoped=true&lang=pug"
import script from "./default.vue?vue&type=script&setup=true&lang=js"
export * from "./default.vue?vue&type=script&setup=true&lang=js"

import "./default.vue?vue&type=style&index=0&id=245ce78c&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245ce78c"]])

export default __exports__